import { 
  SET_DECEASED_DETAILS_ENABLED,
} from './DeceasedDetailsEnabledActions';

export const setDeceasedDetailsEnabledReducer = (state={}, action) =>{
  const { type, enableType, payload } = action;
  switch (type){
  case(SET_DECEASED_DETAILS_ENABLED):{
    return { ...state,
      [enableType]: payload }
  }
  default:
    return state;
  }
}